import { Component, input } from '@angular/core';

import { LandingText, ShootingStar, SpaceParticle } from '../landing.types';
import { LandingStarfield } from './landing-starfield.component';

@Component({
    selector: 'app-landing-intro',
    standalone: true,
    imports: [LandingStarfield],
    templateUrl: './landing-intro.component.html',
    styleUrl: './landing-intro.component.scss'
})
export class LandingIntro {
    readonly text = input.required<LandingText>();
    readonly particles = input.required<SpaceParticle[]>();
    readonly stars = input.required<ShootingStar[]>();
}
